import {
   HealthcareProviderLocation,
   HealthcareProviderLocationQuery,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';
import { HealthcareFacilityLocationSpecialtyCode } from '@dreryk/egabinet-healthcare-provider-published-language-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../translations';

const PSYCHOLOGICAL_HEALTHCARE_FACILITY_SPECIALTY_CODES = [
   HealthcareFacilityLocationSpecialtyCode.of('1790'),
   HealthcareFacilityLocationSpecialtyCode.of('1791'),
];

type GenerateMZ15FormLoaderRenderProps = {
   healthcareProviderLocations: HealthcareProviderLocation[];
};

type GenerateMZ15FormLoaderProps = {
   readonly children: (renderProps: GenerateMZ15FormLoaderRenderProps) => JSX.Element;
};

export const GenerateMZ15FormLoader = (props: GenerateMZ15FormLoaderProps): JSX.Element => {
   const {
      data: healthcareProviderLocations,
      loading: healthcareProviderLocationsLoading,
      error: healthcareProviderLocationsError,
   } = useCqrsSearch<HealthcareProviderLocation>(() => {
      const query = new HealthcareProviderLocationQuery();
      query.excludedHealthcareFacilityLocationSpecialtyCodes = PSYCHOLOGICAL_HEALTHCARE_FACILITY_SPECIALTY_CODES;
      return query;
   });

   if (healthcareProviderLocationsLoading) {
      return <LoaderSpinner />;
   }

   if (healthcareProviderLocationsError) {
      return (
         <Message
            testId={'failedToFetchHealthcareFacilityUnit'}
            label={statisticsTranslationKeys.mz15Form.failedToFetchHealthcareProviderLocations}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      healthcareProviderLocations: healthcareProviderLocations,
   });
};
